import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { jwtDecode } from 'jwt-decode';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

export interface IUser {
  email: string;
  type: string;
  _id: string;
  userName: string;
}

export interface IAuthUser {
  _id: string;
  firstLogin: boolean;
  permits: [];
  active: boolean;
  username: string;
  email: string;
  licenseKey: string;
  role: string;
  practitioner: string;
  iat: number;
  exp: number;
}

// local storage user key
export const LS_USER_KEY = 'user';

const basicAuth = btoa(`${environment.credentials.videoChat.user}:${environment.credentials.videoChat.pwd}`);

@Injectable()
export class AuthService {
  constructor(private readonly http: HttpClient) {}

  private token: string;
  private licenceKey: string;
  private currentUserValue: IUser;

  getToken() {
    return this.token;
  }

  getCurrentUserValue() {
    return this.currentUserValue;
  }

  getRol(id: string) {
    return this.http.get<any>(environment.url + '/roles/' + id, {
      headers: {
        Authorization: `Basic ${basicAuth}`
      }
    });
  }

  mapRoles() {
    return this.http.get<any>(environment.url + '/roles/', {
      headers: {
        Authorization: `Basic ${basicAuth}`
      }
    });
  }

  logout() {
    localStorage.clear();
  }

  login(email: string, password: string): Observable<IUser> {
    const payload = {
      email,
      password
    };
    return this.http
      .post(environment.login, payload, {
        headers: new HttpHeaders({
          Authorization: `Basic ${basicAuth}`
        })
      })
      .pipe(
        map(result => {
          this.token = result['token'];
          const user = result['user'];
          this.licenceKey = user.licenseKey;
          this.currentUserValue = {
            email: user.email,
            _id: user._id,
            type: user.role,
            userName: user.username
          };
          const userLoged = {
            token: this.token,
            licenceKey: this.licenceKey,
            email: user.email,
            _id: user._id,
            type: user.role,
            userName: user.username,
            refreshToken: result['refreshToken'],
            firstLogin: result['user']['firstLogin']
          };
          localStorage.setItem('loginUserName', JSON.stringify(this.currentUserValue));
          return userLoged;
        })
      );
  }

  forgot(email: string) {
    return this.http.post(
      environment.forgotPass,
      { email },
      {
        headers: new HttpHeaders({
          Authorization: `Basic ${basicAuth}`
        })
      }
    );
  }

  activateUser(data: {}) {
    return this.http.post(environment.activateUser, data, {
      headers: new HttpHeaders({
        Authorization: `Basic ${basicAuth}`
      })
    });
  }

  recoveryPass(data: {}) {
    return this.http.post(environment.recoveryPass, data, {
      headers: new HttpHeaders({
        Authorization: `Basic ${basicAuth}`
      })
    });
  }

  logOut() {
    return this.http.post(
      environment.logOut,
      { token: JSON.parse(localStorage.getItem(LS_USER_KEY)).token },
      {
        headers: new HttpHeaders({
          Authorization: `Basic ${basicAuth}`
        })
      }
    );
  }

  updateFirstLogin(data: {}) {
    return this.http.post(environment.updateFirstLogin, data, {
      headers: new HttpHeaders({
        Authorization: `Basic ${basicAuth}`
      })
    });
  }

  getUserInfo(): IAuthUser {
    const token = JSON.parse(localStorage.getItem(LS_USER_KEY)).token;
    return token ? jwtDecode<IAuthUser>(token) : null;
  }

  authTemp(pin: String) {
    return this.http.get<any>(`${environment.url}/auth/room?pin=${pin}`, {
      headers: {
        Authorization: `Basic ${basicAuth}`
      }
    });
  }
}
